// Global colours, constants, and theming throughout the app.
export default {
  colours: {
    nav: "#393939", // Navigation bars
    bg: "radial-gradient(#1a292d, #292929)",
    paper: "rgba(180,180,180,0.05)",
    paperSolid: "#393939",
    active: "rgb(102, 155, 255)",
    activebg: "rgb(35, 45, 57)",
    error: "#FF3F6F;",
    success: "#11cc33",
    caution: "#fce83a",
    warning: "#ffb302",
    identifier: "#66FFCC", // IDs and other technical things
    activenew: "#09CFEC",
    /* General text colours */
    text: {
      primary: "#F7F6F6",
      secondary: "#E7E6E6",
      tertiary: "#777",
    },
    /* Subtle colours for different RSO types, e.g. for icons */
    rsoType: {
      debris: "#e6d5ad",
      "rocket body": "#e6ade1",
      payload: "#adc8e6",
    },
  },
  corners: "0.5rem", // Radius of rounded corners on block elements, like Paper
}

// colourFromProps is a helper function to determine the colour
// to use - such as for text or an icon - based on which boolean
// flags like 'primary', 'success', 'error', 'active' etc have been
// set.
export const colourFromProps = (props) =>
  props.primary
    ? props.theme.colours.text.primary
    : props.secondary
      ? props.theme.colours.text.secondary
      : props.tertiary
        ? props.theme.colours.text.tertiary
        : props.success
          ? props.theme.colours.success
          : props.error
            ? props.theme.colours.error
            : props.warning
              ? props.theme.colours.warning
              : props.caution
                ? props.theme.colours.caution
                : props.delete
                  ? props.theme.colours.error
                  : props.active
                    ? props.theme.colours.active
                    : props.new
                      ? props.theme.colours.activenew
                      : undefined
